
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  Gift 
} from "@dndModels";

/**
 * This represents a Gift with the options chosen for a character.
 */
export class CharacterGift extends CharacterFeatureSource {
  source: Gift | null = null;

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.gift_id) {
        this.source_id = obj.gift_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          this.char_feature_bases.push(fb);
        });
      }
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj
    };
  }

  clone(drop_ids = false): CharacterGift {
    const clone = new CharacterGift();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterGift, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.source = copyMe.source;
  }
}